export const useLoginStyles = {
  loginContainer: {
    display: 'flex',
    height: '100vh',
  },
  loginLeft: {
    backgroundColor: '#fff',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loginBox: {
    width: '300px',
    textAlign: 'left',
  },
  loginTitle: {
    fontSize: '2rem',
    color: '#2b3a55',
    fontWeight: 'bold',
  },
  loginSubtitle: {
    color: '#9aa2b1',
    marginBottom: '1rem',
  },
  loginInfo: {
    backgroundColor: '#e6f4ff',
    padding: '1rem',
    borderRadius: '5px',
    fontSize: '0.9rem',
    marginBottom: '1rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    marginBottom: '0.5rem',
    fontWeight: 'bold',
    color: '#4a4a4a',
  },
  input: {
    padding: '10px',
    marginBottom: '15px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontSize: '1rem',
  },
  rememberForgot: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
    fontSize: '0.9rem',
  },
  loginButton: {
    backgroundColor: '#635dff',
    color: 'white',
    padding: '10px',
    fontSize: '1rem',
    border: 'none',
    marginTop: '1rem',
    borderRadius: '5px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#534fd1',
    },
  },
  loginRight: {
    flex: 1,
    backgroundColor: '#1c2a4d',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: '3rem',
  },
  loginRightTitle: {
    fontSize: '2.5rem',
    marginBottom: '1rem',
  },
  loginRightText: {
    fontSize: '1.2rem',
    color: '#aab8cf',
  },
};